<template>
  <div class="possibleWinWrapper">
    <div class="possibleWin">
      <div>
        {{ translations.general_possible_winning }}
      </div>
      <div>
        {{ possibleWinCombo.possibleWinnings }}
      </div>
    </div>
    <div class="payinTax" v-if="isPayinTaxActive">
      <div>
        {{ translations.general_payin_tax }}
      </div>
      <div>
        {{ possibleWinCombo.possiblePayinTax }}
      </div>
    </div>
    <div class="payoutTax"
      v-if="isPayoutTaxActive && Number(possibleWinCombo.possiblePayoutTax) > 0">
      <div>
        {{ translations.general_payout_tax }}
      </div>
      <div>
        {{ decimalFormatNumber(possibleWinCombo.possiblePayoutTax) }}
      </div>
    </div>
    <div class="payoutAfterTax"
      v-if="isPayoutTaxActive && Number(possibleWinCombo.possiblePayoutTax) > 0">
      <div>
        {{ translations.general_payout_after_tax || 'Payout After Tax' }}
      </div>
      <div>
        {{ decimalFormatNumber(
          possibleWinCombo.possibleWinnings - possibleWinCombo.possiblePayoutTax
        ) }}
      </div>
    </div>
    <div class="odds">
      <div>
        {{ translations.general_total_odds }}
      </div>
      <div>
        {{ totalOdds }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'BetslipPossibleWinCombo',
  methods: {
    ...mapActions('gamesBetslip', ['calculatePossibleWinCombo']),
  },
  computed: {
    ...mapGetters('gamesBetslip', [
      'possibleWinCombo',
      'totalOdds',
      'taxes',
      'decimalFormatNumber',
    ]),
    ...mapGetters(['translations']),
    isPayinTaxActive() {
      return !this.taxes.payin.hideTax;
    },
    isPayoutTaxActive() {
      return !this.taxes.payout.hideTax;
    },
  },
  mounted() {
    this.calculatePossibleWinCombo();
  },
};
</script>

<style lang="scss" scoped>
.possibleWinWrapper {
  margin-top: 8px;
  margin-bottom: 8px;

  .possibleWin, .payinTax, .payoutTax {
    margin-bottom: 2px;
  }

  .payinTax, .payoutTax {
    color: var(--text-primary-2);
  }

  .payinTax, .odds, .payoutTax {
    font-size: 12px;
  }

  .possibleWin, .payinTax, .odds, .payoutTax {
    display: flex;
    justify-content: space-between;
  }

  .payoutAfterTax {
    display: flex;
    justify-content: space-between;
    font-weight: 500;
    font-size: 13px;
    color: var(--text-primary-1);
    margin: 4px 0;
    padding: 4px 0;
    border-top: 1px solid rgba(var(--text-primary-1-rgb), 0.2);
    border-bottom: 1px solid rgba(var(--text-primary-1-rgb), 0.2);
  }
}
</style>
